import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import multipleAccountsActions from '../actions/multipleAccounts';

function confirmAccountMultipleAccounts(store, action) {
    const confirmAccountDetails = action.payload.confirmAccountDetails;
    request.post(`/${config.url_prefix}/api/multipleAccounts`)
        .send({
            data: confirmAccountDetails
        })
        .set('x-homeaway-site', confirmAccountDetails.primarySite.name)
        .end((error, response) => {
            if (error) {
                const errorKey = 'ipmob.internal.server.error';
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(multipleAccountsActions.alertError(errorKey));
            } else if (response.statusCode === 200) {
                // Redirect to the selected account site
                let {protocol, host, pathname} = window.location;
                pathname = `/p/onboard?site=${confirmAccountDetails.primarySite.name}`;
                window.location = `${protocol}//${host}${pathname}`;
            } else {
                const errorKey = 'ipmob.error.process.request';
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(multipleAccountsActions.alertError(errorKey));
            }
        });
}

export default confirmAccountMultipleAccounts;
